import { render, staticRenderFns } from "./project-step-description.vue?vue&type=template&id=06bea760&"
import script from "./project-step-description.vue?vue&type=script&lang=js&"
export * from "./project-step-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports